import { realityInfo } from "./realityInfo";

export const getStorageImageUrl = (name: string) => {
  return realityInfo.storageUrl + name;
};
